function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v15H0V7.5Z",
    style: {
      fill: "#009543"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v10H0V7.5Z",
    style: {
      fill: "#ed4135"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v5H0v-5Z",
    style: {
      fill: "#0035ad"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 15,
    r: 4.916,
    transform: "translate(-5.039 24.941) rotate(-89.774)",
    style: {
      fill: "#fae600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,10.001c-2.756,0-4.999,2.242-4.999,4.999s2.242,4.999,4.999,4.999,4.999-2.242,4.999-4.999-2.243-4.999-4.999-4.999ZM5.167,15c0-2.631,2.115-4.768,4.733-4.823v1.063c-.3.133-.54.253-.588.518-.006.035-.014.401-.023.491,0,0,.051.007.173-.092.053-.043.218-.074.438-.208v.572c-.319.05-.567.314-.567.647s.248.597.567.647v.147c-.253-.013-.477-.089-.667-.477-.106-.217-.383-.551-.383-.551,0,0,.13.374.15.75.029.553.515.608.9.613v.104h-.733v.2h.733v.108c-.319.032-.567.199-.567.409s.248.378.567.409v.107h-.733v.2h.733v.11c-.559.026-.84.246-.87.569-.066.706-.197,1.255-.197,1.255,0,0,.21-.259.455-.866.114-.279.363-.447.612-.485v.08c-.254.071-.45.38-.45.771s.196.7.45.771v.246c-.331.009-.654.079-.822.212-.23.181-.787.734-.987.94-1.717-.742-2.924-2.45-2.924-4.437ZM11.821,19.471c-.197-.21-.698-.737-.987-.975-.153-.126-.435-.193-.734-.208v-.25c.254-.071.45-.38.45-.771s-.196-.7-.45-.771v-.08c.249.038.498.206.612.485.245.607.455.866.455.866,0,0-.131-.549-.197-1.255-.03-.323-.311-.543-.87-.569v-.11h.733v-.2h-.733v-.107c.319-.032.567-.199.567-.409s-.248-.378-.567-.409v-.108h.733v-.2h-.733v-.104c.385-.006.871-.06.9-.613.02-.376.15-.75.15-.75,0,0-.277.334-.383.551-.19.388-.414.463-.667.477v-.147c.319-.05.567-.314.567-.647s-.248-.597-.567-.647v-.715c.195-.162.416-.411.636-.807.122-.219.064-.315.064-.315,0,0,.006.014-.084.092-.198.172-.413.282-.616.375v-.972c2.618.055,4.733,2.192,4.733,4.823,0,2.02-1.248,3.75-3.012,4.471Z",
    style: {
      fill: "#000000"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNc);
export default __webpack_public_path__ + "static/media/NC.39c3a6263c6de08c0e792a13a798e6a5.svg";
export { ForwardRef as ReactComponent };